<template>
  <div class="contact-page" id="app">
    <headerView :seletedindex="seletedindex" />

    <!-- 顶部横幅 -->
    <div
      class="banner"
      :style="{
        backgroundImage:
          'url(' +
          contactUsBanner.imgUrl +
          ')',
      }"
    >
      <!-- <div class="banner-content">
        <h1>{{ contactUsBanner.title }}</h1>
        <p>{{ contactUsBanner.subTitle }}</p>
      </div> -->
    </div>

    <!-- 子公司一览 -->
    <div class="subsidiary-section">
      <h2 class="subsidiary-title">子公司一览</h2>
      <div class="subsidiary-cards">
        <div
          class="subsidiary-card"
          v-for="(subsidiary, index) in subsidiaries"
          :key="index"
        >
          <div class="subsidiary-icon">
            <img :src="subsidiary.icon" alt="" srcset="" />
          </div>
          <h3 class="subsidiary-name">{{ subsidiary.name }}</h3>
          <div class="subsidiary-info">
            <div class="info-item">
              <i class="iconfont icon-zhinanzhen"></i>
              <span>{{ subsidiary.location }}</span>
            </div>
          </div>
          <div class="subsidiary-intro">
            <p>{{ subsidiary.intro }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="news_information">
      <p class="news_information_title">联系方式</p>
      <div class="news_information_div">
        <el-card class="news_information_card">
          <img
            src="@/assets/images/lyy.jpg"
            draggable="false"
            alt
            class="news_information_card_img"
          />
          <p class="news_information_card_p2">永安广场校区</p>
        </el-card>
        <el-card class="news_information_card">
          <img
            src="@/assets/images/lhy.jpg"
            draggable="false"
            alt
            class="news_information_card_img"
          />
          <p class="news_information_card_p2">吕四港校区</p>
        </el-card>
        <el-card class="news_information_card">
          <img
            src="@/assets/images/yme.jpg"
            draggable="false"
            alt
            class="news_information_card_img"
          />
          <p class="news_information_card_p2">上海春申校区</p>
        </el-card>
      </div>
    </div>
    <Map class="mapstyle" ref="map" @updateLocation="updateLocation" />

    <!-- 常见问题 -->
    <div class="faq-section">
      <h2>常见问题</h2>
      <div class="faq-grid">
        <div class="faq-item">
          <h3>早鹰教育的课程适合哪些年龄段？</h3>
          <p>
            早鹰教育提供从幼儿园到高中的全年龄段课程，涵盖学科辅导、兴趣培养、编程启蒙等
          </p>
        </div>
        <div class="faq-item">
          <h3>售后服务如何保障？</h3>
          <p>我们提供7x24小时技术支持服务，并有专业的团队为您解决问题。</p>
        </div>
        <div class="faq-item">
          <h3>早鹰的课程可以试听吗？</h3>
          <p>可以！我们为所有新学员提供免费试听课程，体验我们的教学服务。</p>
        </div>
        <div class="faq-item">
          <h3>早鹰的师资力量如何？</h3>
          <p>
            早鹰教育拥有一支经验丰富的教师团队，所有教师均经过严格筛选和专业培训。
          </p>
        </div>
      </div>
    </div>

    <footerView />
  </div>
</template>

<script>
import headerView from "@/components/header.vue";
import footerView from "@/components/footer.vue";
import { homeBanner, submitContactUs } from "@/api/index";
import Map from "@/components/Amap.vue";

export default {
  name: "ContactUs",
  components: {
    headerView,
    footerView,
    Map,
  },
  data() {
    return {
      seletedindex: 5,
      contactUsBanner: {
        title: "",
        subTitle: "",
        imgUrl: "",
      },
      formContactUs: {
        name: "",
        mobile: "",
        email: "",
        subject: "",
        content: "",
      },
      subsidiaries: [
        {
          name: "广东早鹰教育研究院",
          location: "佛山市禅城区江湾一路18号西区四座2层A16-2",
          icon: require('@/assets/images/guangdong.png'),
          intro:
            "集团最早成立的研发中心。主导九大核心能力模型迭代研发，设计全国性科技赛事体系与评估标准。",
        },
        {
          name: "上海早鹰培优信息技术有限公司",
          location: "上海市宝山区长建路199号9幢",
          icon: require('@/assets/images/shanghai.png'),
          intro:
            "推进长三角地区‘智改数转网联’项目，提供政企数字化培训解决方案，提供覆盖全国的科创教练培训。承担国际教育合作枢纽职能，负责多语种课程体系及师资标准海外输出。",
        },
        {
          name: "江苏早鹰培优信息技术有限公司",
          location: "启东市汇龙镇人民中路733-2号",
          icon: require('@/assets/images/nantong.png'),
          intro:
            "立足全国教育高地南通，衔接当地高端教育资源，具体落实当地业务，负责集团科普教育基地运营与科技文化实践活动落地，主导省市级赛事承办。",
        },
        {
          name: "青岛早鹰信息科技有限公司",
          location: "山东省青岛市黄岛区融合路669号607室",
          icon: require('@/assets/images/qingdao.png'),
          intro:
            "由早鹰集团与青岛空天动力结构安全研究所全资子公司青岛西联空天创新科技有限公司强强联合，共同发起成立的高科技创新企业。2025年6月28日在低空经济现代产业学院揭牌仪式上，双方完成合作协议的签署并于同年7月扬帆起航，投入运营",
        },
      ],
      rules: {
        name: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          {
            pattern: /^[\u4E00-\u9FA5]{2,10}(·[\u4E00-\u9FA5]{2,10}){0,2}$/,
            message: "请输入真实姓名",
          },
        ],
        mobile: [
          { required: true, message: "请输入电话", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            pattern: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
            message: "请输入有效的邮箱",
            trigger: "blur",
          },
        ],
        subject: [{ required: true, message: "请输入主题", trigger: "blur" }],
        content: [
          { required: true, message: "请输入留言内容", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.$nextTick(() => {
      this.getcontactUsBanner();
    });
  },
  methods: {
    // 点击地图后得到位置信息
    updateLocation(Addr) {
      console.log(Addr);
    },
    async getcontactUsBanner() {
      const res = await homeBanner("/api/zaoying/banner", { category_id: 9 });
      if (res && res.length > 0) {
        this.contactUsBanner = res[0];
      }
    },
    submitForm() {
      this.$refs.formContactUs.validate(async (valid) => {
        if (valid) {
          try {
            const form1 = await submitContactUs(
              "/api/Policy/AddContact",
              this.formContactUs
            );
            if (form1) {
              this.$message({
                message: "提交成功",
                type: "success",
              });
              this.$refs.formContactUs.resetFields();
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.contact-page {
  min-height: 100vh;
  background-color: #fff; /* 改回纯白色背景 */
}

.banner {
  background-size: cover;
  background-position: center;
  height: 25vw; /* 设置为视窗宽度的1/3 */
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
}

.banner-content {
  max-width: 800px;
  padding: 0 20px;
}

.banner h1 {
  font-size: 42px; /* 增大标题字体 */
  margin-bottom: 25px;
  font-weight: 500;
}

.banner p {
  font-size: 20px; /* 增大描述文字字体 */
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
}

.contact-cards {
  display: flex;
  justify-content: center;
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
  gap: 30px;
}

.contact-card {
  background: white; /* 白色卡片背景 */
  padding: 40px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  text-align: center;
  flex: 1;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-wrapper {
  width: 80px;
  height: 80px;
  background: #f0f7ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 25px;
}

.contact-card i {
  font-size: 36px;
  color: #1890ff;
}

.card-title {
  font-size: 20px;
  color: #333;
  margin-bottom: 25px;
  font-weight: 500;
}

.contact-card .info {
  text-align: center;
  width: 100%;
}

.contact-card .info p {
  margin: 12px 0;
  color: #666;
  font-size: 15px;
}

.text-bold {
  font-weight: 500;
}

.primary {
  color: #1890ff;
  font-size: 18px !important;
}

.contact-form {
  background: white;
  width: 100%; /* 设置为视窗宽度 */
  margin-left: calc(-50vw + 50%); /* 负边距技巧使div撑满宽度 */
  margin-right: calc(-50vw + 50%);
  margin-top: 60px;
  margin-bottom: 60px;
  padding: 40px 0; /* 移除左右padding */
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

/* 添加内容容器来控制表单内容的宽度 */
.contact-form form {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px; /* 添加内容的左右padding */
}

.contact-form h2,
.form-desc {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px; /* 标题和描述文字也需要左右padding */
}

.contact-form h2 {
  font-size: 24px;
  color: #333;
  margin-bottom: 15px;
  font-weight: 500;
  text-align: center;
}

.form-desc {
  color: #666;
  margin-bottom: 30px;
  text-align: center; /* 描述文字居中 */
}

.form-group {
  margin-bottom: 20px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
  font-size: 15px;
}

.required {
  color: #ff4d4f;
  margin-left: 4px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s;
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: #bfbfbf;
}

.el-form-item {
  margin: 10px auto;
}

.submit-btn {
  background: #1890ff;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  width: 100%;
  max-width: 800px; /* 提交按钮最大宽度 */
  margin: 20px auto;
  display: block;
  transition: background 0.3s;
}

.submit-btn:hover {
  background: #40a9ff;
}

.faq-section {
  width: 100%;
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
}

.faq-section h2 {
  font-size: 24px;
  color: #333;
  margin-bottom: 30px;
  font-weight: 500;
  text-align: center;
}

.faq-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px; /* 增加间距 */
  margin: 0 auto;
}

.faq-item {
  background: white; /* 白色FAQ背景 */
  padding: 25px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: none;
}

.faq-item h3 {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
  font-weight: normal;
}

.faq-item p {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

/* 添加响应式布局调整 */
@media (max-width: 1240px) {
  .contact-form,
  .faq-section {
    margin: 60px 20px;
  }
}

@media (max-width: 768px) {
  .contact-form {
    padding: 30px 0; /* 移除左右padding，只保留上下padding */
  }

  .contact-cards {
    flex-direction: column;
    align-items: center;
    margin: 40px 20px;
  }

  .contact-card {
    width: 100%;
    margin: 10px 0;
  }

  .faq-grid {
    grid-template-columns: 1fr;
  }

  .banner {
    height: 50vw; /* 在移动端可以适当调整比例 */
  }
}

.form-group input.message-input {
  height: 100px; /* 设置留言内容输入框的高度 */
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s;
}

.form-group input:focus,
.form-group textarea:focus {
  border-color: #1890ff;
  outline: none;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}
.news_information {
  width: 100%;
}

.news_information_title {
  font-size: 25px;
  padding: 63px 0px 13px 0px;
  text-align: center;
}
.news_information_div {
  width: 50%;
  margin: 0px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
}
.news_information_div .el-card__body,
.el-main {
  padding: 0px;
}
.news_information_card {
  margin: 0;
  padding: 0;
  min-width: 20px;
  width: 20%;
  line-height: 2;
  margin: 20px 0px;
  border-radius: 15px;
  text-align: left;
  cursor: pointer;
}

.news_information_card_img {
  width: 100%;
  height: 100%;
}

.news_information_card_p2 {
  font-weight: bold;
  font-size: 19px;
  text-align: center;
  white-space: nowrap;
}

.mapstyle {
  width: 50%;
  margin: 0px auto;
}

/* 子公司一览样式 */
.subsidiary-section {
  width: 100%;
  max-width: 1200px;
  margin: 60px auto;
  padding: 0 20px;
}

.subsidiary-title {
  font-size: 32px;
  font-weight: 500;
  color: #000;
  text-align: center;
  margin-bottom: 40px;
}

.subsidiary-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.subsidiary-card {
  background: #fff;
  border-radius: 8px;
  padding: 30px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.subsidiary-icon {
  margin-bottom: 20px;
}

.subsidiary-icon img {
  width: 300px;
  border-radius: 10px;
}

.subsidiary-name {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin-bottom: 15px;
  line-height: 1.4;
}

.subsidiary-services {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.5;
  min-height: 40px;
}

.subsidiary-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  max-width: max-content;
  margin: 0 auto;
}

.info-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  font-size: 14px;
  color: #666;
}

.info-item .iconfont {
  font-size: 16px;
  color: #999;
}

.subsidiary-intro {
  width: 100%;
  margin-top: 25px;
  padding: 0 10px;
}

.subsidiary-intro p {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  text-align: left;
  margin: 0;
  max-width: 100%;
  text-indent: 2em;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .subsidiary-cards {
    grid-template-columns: 1fr;
  }

  .subsidiary-title {
    font-size: 28px;
  }
}
</style>